var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',{attrs:{"heading":"Daftar Pasien","breadcrumb":[
      {
        label: 'Daftar Pasien',
        link: '/pasien'
      },
      {
        label: 'Tambah Pasien',
        active: true
      }
    ]}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card card-box"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('PasienForm',{on:{"keluar":_vm.goingPlaces,"submitForm":_vm.submitForm}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header",staticStyle:{"background-color":"#d3e8eb"}},[_c('h4',{staticClass:"text-capitalize my-2"},[_vm._v("tambah pasien")])])}]

export { render, staticRenderFns }